import React, { memo, useEffect, useState } from 'react';

import Box from '@mui/material/Box';
import InputMask from 'react-input-mask';

import AxlModal from 'AxlMUIComponent/AxlModal';
import AxlConfirmation from 'AxlMUIComponent/AxlConfirmation';
import { images } from '../../constants/images';
import styles, { InputNoPadding, InputWrapper, ParcelLabel, Select, Unit } from './styles';

const dimensionHolder = ' x ';
const typeIcon = (type) => {
  switch (type) {
    case 'box':
      return images.icon.box;
    case 'bag':
      return images.icon.bag;
    case 'tote':
      return images.icon.tote;
    default:
      return images.icon.box;
  }
};
// length x width x height
const renderDimension = (dimension) => `${dimension.length}${dimensionHolder}${dimension.width}${dimensionHolder}${dimension.height}`;
const ParcelItem = (props) => {
  const { parcel, handleChangeField, parcelTypeList, isEnableEdit, onDownloadLabel, deleteParcel, isShowDownload } = props;
  const { id, parcel_id, dimensions, weight, type } = parcel;
  const typeSrc = typeIcon(type);
  const [isShowPanel, setIsShowPanel] = useState(false);
  const [isDeleteModalClose, setIsDeleteModalClose] = useState(true);
  const onChangeDimension = (e, id) => {
    if (e) handleChangeField(e.target.value, id, 'dimensions');
  };
  const onSelectType = (e, id) => {
    if (e) handleChangeField(e, id, 'type');
  };
  const onChangeParcelId = (e, id) => {
    if (e) handleChangeField(e.target.value, id, 'parcel_id');
  };
  const onChangeWeight = (e, id) => {
    if (e) handleChangeField(e.target.value, id, 'weight');
  };
  useEffect(() => {
    if (isEnableEdit) {
      setIsShowPanel(true);
    }
  }, [isEnableEdit]);
  return (
    <Box sx={styles.parcelContainer}>
      <div style={styles.panelHeader}>
        <div style={styles.panelHeaderTitle}>
          <div style={styles.typeIconWrapper}>
            <img src={typeSrc} style={styles.typeIcon} />
          </div>
          {parcel_id}
        </div>
        <div style={styles.panelHeaderRight}>
          {isEnableEdit ? (
            <AxlModal
              isClose={isDeleteModalClose}
              onRendered={() => setIsDeleteModalClose(false)}
              trigger={
                <button style={styles.btnTrash}>
                  <img src={images.icon.trash} />
                </button>
              }
            >
              <AxlConfirmation
                title={`Are you sure to delete this parcel?`}
                subTitle={parcel_id && `Parcel ID: ${parcel_id}`}
                doText={`OK`}
                onDo={() => deleteParcel(id)}
                closeText={`Cancel`}
                onClose={() => setIsDeleteModalClose(true)}
              />
            </AxlModal>
          ) : (
            <React.Fragment>
              {isShowDownload && parcel_id && (
                <div style={styles.parcelLabel}>
                  <button style={styles.btnDownload} onClick={onDownloadLabel}>
                    <img src={images.icon.downloadColor} style={styles.labelIcon} />
                    LABEL
                  </button>
                </div>
              )}
              <div style={styles.panelHeaderArrow} onClick={() => setIsShowPanel(!isShowPanel)}>
                <i className={!isShowPanel ? 'fa fa-angle-down' : 'fa fa-angle-up'} />
              </div>
            </React.Fragment>
          )}

          <div></div>
        </div>
      </div>
      {isShowPanel && (
        <Box sx={{ display: 'flex', ...styles.parcelContent }}>
          <Box sx={{ flex: 1, ...styles.firstCol }}>
            <ParcelLabel>Parcel ID:</ParcelLabel>
            {isEnableEdit ? (
              <InputNoPadding>
                <input style={styles.input} onChange={(e) => onChangeParcelId(e, id)} name="parcel_id" value={parcel_id} />
              </InputNoPadding>
            ) : (
              <div>{parcel_id}</div>
            )}
          </Box>
          <Box sx={{ flex: 1, ...styles.colWide }}>
            <ParcelLabel>Dimension:</ParcelLabel>

            {isEnableEdit ? (
              <InputWrapper>
                <InputMask
                  value={renderDimension(dimensions)}
                  name="dimension"
                  onChange={(e) => onChangeDimension(e, id)}
                  alwaysShowMask
                  maskChar=" "
                  mask="99 x 99 x 99"
                  style={styles.input}
                />
                <Unit>in</Unit>
              </InputWrapper>
            ) : (
              <span>{renderDimension(dimensions)} in</span>
            )}
          </Box>
          <Box sx={{ flex: 1, ...styles.normalCol }}>
            <ParcelLabel>Weight:</ParcelLabel>
            {isEnableEdit ? (
              <InputWrapper style={styles.inputWeight}>
                <input style={styles.input} type="number" min="0" onChange={(e) => onChangeWeight(e, id)} name="weight" value={weight.value} />
                <Unit>lbs</Unit>
              </InputWrapper>
            ) : (
              <span>{weight.value} lbs</span>
            )}
          </Box>
          <Box sx={{ flex: 1, ...styles.normalCol }}>
            <ParcelLabel>Type:</ParcelLabel>
            {isEnableEdit ? (
              <Select
                onChange={(s) => {
                  onSelectType(s.target.value, id);
                }}
                defaultValue={type}
              >
                <option disabled selected value>
                  ---
                </option>
                {parcelTypeList.map((type, index) => (
                  <option key={`parcel-type-${index}`} value={type} style={styles.option}>
                    {type}
                  </option>
                ))}
              </Select>
            ) : (
              <div style={styles.type}>{type}</div>
            )}
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default memo(ParcelItem);
